import { render, staticRenderFns } from "./PaidFeatureNotice.vue?vue&type=template&id=25432a34&scoped=true"
import script from "./PaidFeatureNotice.vue?vue&type=script&lang=js"
export * from "./PaidFeatureNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25432a34",
  null
  
)

export default component.exports